import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { Footer } from '../../../../components';
import { fetchDeploymentRefreshTime } from '../../../../actions/portalConfig';
import { getDeploymentRefreshTime } from '../../../../reducers/portalConfig';
import {
  fetchDeploymentProxyList,
  fetchDeploymentStatus,
  deployGatewayBundle,
  redeployGatewayBundle,
  undeployGatewayBundle,
} from '../../../../actions/gatewayBundle';
import {
  getGatewayBundleProxyListResults,
  getGatewayBundlesProxyListTotalElements,
  getGatewayBundlesProxyListTotalPages,
  getGatewayBundleProxyListErrors,
  getProxyErrors,
} from '../../../../reducers/gatewayBundle';
import styles from './styles';
import { getI18n } from '../../../../utils/intl';
import {
  ALERT_ERROR,
  GRID_ROWS_PER_PAGE_OPTIONS,
  GRID_ROWS_PER_PAGE_DEFAULT_OPTION,
} from '../../../../constants';
import DeploymentTable from "./DeploymentTable";

export const DeploymentsRaw = (props) => {
  const {
    bundleUuid,
    gatewayBundleDetails,
    deploymentProxyList = [],
    deploymentErrors = [],
    listProxyErrors = [],
    notifyMessages,
    totalPages,
    totalElements = 0,
    classes,
  } = props;

  const intl = getI18n(useIntl());
  const [filterByName, setFilterByName] = useState('');
  const [filterByState, setFilterByState] = useState('all');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(GRID_ROWS_PER_PAGE_DEFAULT_OPTION);

  useEffect(() => {
    if (bundleUuid) {
      props.fetchDeploymentProxyList(bundleUuid, filterByName, filterByState, page, rowsPerPage);
      props.fetchDeploymentRefreshTime();
    }
  }, [bundleUuid]);

  useEffect(() => {
    if (listProxyErrors.length > 0) {
      notifyMessages(ALERT_ERROR, intl.getI18nMessage('error.gateway.bundle.proxy.list.fetch'));
    } else {
      notifyMessages('', '');
    }
  }, [listProxyErrors]);

  const onFilterByNameChange = (value) => {
    setFilterByName(value);
  };

  const onFilterByNameKeyPress = (e) => {
    if (e.key === 'Enter') {
      props.fetchDeploymentProxyList(bundleUuid, filterByName, filterByState, page, rowsPerPage);
    }
  };

  const onFilterByStateChange = (newFilterByState) => {
    setFilterByState(newFilterByState);
    props.fetchDeploymentProxyList(bundleUuid, filterByName, newFilterByState, page, rowsPerPage);
  };

  const onChangePage = (newPage) => {
    if (page === newPage) { return; }
    setPage(newPage);
    props.fetchDeploymentProxyList(bundleUuid, filterByName, filterByState, newPage, rowsPerPage);
  };
  const onChangePreviousPage = () => { onChangePage(page - 1); };
  const onChangeNextPage = () => { onChangePage(page + 1); };

  const onChangeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    props.fetchDeploymentProxyList(bundleUuid, filterByName, filterByState, 0, newRowsPerPage);
  };

  const checkStatus = () => {
    props.fetchDeploymentStatus(bundleUuid, filterByName, filterByState, page, rowsPerPage);
  };

  return (
    <div
      id="gatway-bundle-detailsdeployments-container"
      data-apim-test={'gatway-bundle-detailsdeployments-container'}
      className={classes.deploymentsContainer}
    >
        <DeploymentTable
          deploymentProxyList={deploymentProxyList}
          gatewayBundleDetails={gatewayBundleDetails}
          deployGatewayBundle={props.deployGatewayBundle}
          redeployGatewayBundle={props.redeployGatewayBundle}
          undeployGatewayBundle={props.undeployGatewayBundle}
          checkStatus={checkStatus}
          refreshTime={props.refreshTime}
          deploymentErrors={deploymentErrors}
          filterByState={filterByState}
          onFilterByStateChange={onFilterByStateChange}
          filterByName={filterByName}
          onFilterByNameChange={onFilterByNameChange}
          onFilterByNameKeyPress={onFilterByNameKeyPress}
          page={page}
          totalElements={totalElements}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={GRID_ROWS_PER_PAGE_OPTIONS}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onChangePage={onChangePage}
          onChangePreviousPage={onChangePreviousPage}
          onChangeNextPage={onChangeNextPage}
          labelRowsPerPage={intl.getI18nMessage('label.pagination.items.per.page')}
        />
      <Footer />
    </div>
  );
};

const mapStateToProps = state => ({
  deploymentProxyList: getGatewayBundleProxyListResults(state),
  totalPages: getGatewayBundlesProxyListTotalPages(state),
  totalElements: getGatewayBundlesProxyListTotalElements(state),
  refreshTime: getDeploymentRefreshTime(state),
  deploymentErrors: getProxyErrors(state),
  listProxyErrors: getGatewayBundleProxyListErrors(state),
});

const mapDispatchToProps = {
  fetchDeploymentProxyList,
  fetchDeploymentStatus,
  fetchDeploymentRefreshTime,
  deployGatewayBundle,
  undeployGatewayBundle,
  redeployGatewayBundle,
};

DeploymentsRaw.propTypes = {
  bundleUuid: PropTypes.string,
  gatewayBundleDetails: PropTypes.object,
  deploymentProxyList: PropTypes.arrayOf(PropTypes.object),
  deploymentErrors: PropTypes.arrayOf(PropTypes.object),
  totalPages: PropTypes.number,
  totalElements: PropTypes.number,
  classes: PropTypes.object,
  undeployGatewayBundle: PropTypes.func,
  listProxyErrors: PropTypes.arrayOf(PropTypes.object),
  notifyMessages: PropTypes.func,
  fetchDeploymentProxyList: PropTypes.func,
  fetchDeploymentRefreshTime: PropTypes.func,
  fetchDeploymentStatus: PropTypes.func,
  refreshTime: PropTypes.func,
  deployGatewayBundle: PropTypes.func,
  redeployGatewayBundle: PropTypes.func,
};
DeploymentsRaw.displayName = 'Deployments';

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(DeploymentsRaw);
